import { Box, Toolbar } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import { Ref, useState } from "react";
import { useTranslation } from "react-i18next";
import { checkCustomLogicFe, getEnvironmentVariables } from "../../utils/general";

const LOGO_PATH = "/logo/LOGO_PREFOOTER.png";

const StyledPreFooter = styled(Box)(({ theme }) => ({
  background: theme.customColors?.backgroundPrimaryLighterAlternative,
  display: "flex",
  justifyContent: "center",
  padding: "16px 42px",
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    padding: "12px 20px"
  }
}));

export function PreFooter({ preFooterRef = null }: { preFooterRef?: Ref<unknown> | undefined }) {
  const theme = useTheme();
  const { t } = useTranslation();
  const { customLogicFe } = getEnvironmentVariables();
  const [isLogoAvailable, setIsLogoAvailable] = useState(true);

  const showPreFooter = checkCustomLogicFe({ envVariable: customLogicFe, strValueToCheck: "prefooter" });

  if (!showPreFooter || !isLogoAvailable) return null;

  return (
    <StyledPreFooter
      component="section"
      ref={ preFooterRef }
    >
      <Toolbar disableGutters
        sx={ {
          alignItems: "center",
          justifyContent: "flex-end",
          maxWidth: theme.breakpoints.values.max,
          width: "100%"
        } }
      >
        <img
          alt={ t("logo") }
          src={ LOGO_PATH }
          onError={ () => setIsLogoAvailable(false) }
          style={ {
            display: "block",
            height: "48px",
            maxWidth: "100%",
            objectFit: "contain",
            width: "auto"
          } }
        />
      </Toolbar>
    </StyledPreFooter>
  );
}
